import React, { useState } from "react";
import LoyaltyConfig from "./LoyaltyConfig";
import LoyaltyTransactions from "./LoyaltyTransactions";
import "./LoyaltyPointsStyle.css";

const tabs = [
  { key: "config", label: "Configuration" },
  { key: "transactions", label: "Transactions" },
];

const LoyaltyPointsPage = () => {
  const [activeTab, setActiveTab] = useState("config");

  return (
    <div className="card-head order-card">
      <h2 className="pb-2">Loyalty Points</h2>

      <div className="loyalty-tabs">
        <ul className="nav nav-tabs">
          {tabs.map((tab) => (
            <li className="nav-item" key={tab.key}>
              <button
                className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
                type="button"
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="loyalty-tab-content">
        {activeTab === "config" && <LoyaltyConfig />}
        {activeTab === "transactions" && <LoyaltyTransactions />}
      </div>
    </div>
  );
};

export default LoyaltyPointsPage;
